var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSandGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.25C3 2.11193 3.11193 2 3.25 2H12.75C12.8881 2 13 2.11193 13 2.25V3.15C13 3.28807 12.8881 3.4 12.75 3.4H12.2V5.14857C12.2 5.52821 12.0204 5.88547 11.7156 6.11186L9.17391 8L11.7156 9.88814C12.0204 10.1145 12.2 10.4718 12.2 10.8514V12.6H12.75C12.8881 12.6 13 12.7119 13 12.85V13.75C13 13.8881 12.8881 14 12.75 14H3.25C3.11193 14 3 13.8881 3 13.75V12.85C3 12.7119 3.11193 12.6 3.25 12.6H3.80005V10.8514C3.80005 10.4718 3.9797 10.1145 4.28446 9.88814L6.82619 8L4.28446 6.11186C3.9797 5.88547 3.80005 5.52821 3.80005 5.14856V3.4H3.25C3.11193 3.4 3 3.28807 3 3.15V2.25ZM5.20005 12.6H10.8V10.952L8.00005 8.87201L5.20005 10.952V12.6ZM5.20005 5.04799V3.4H10.8V5.04799L8.00005 7.12799L5.20005 5.04799Z",
    fill: "#070A26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandGlass);
export default __webpack_public_path__ + "static/media/sandGlass.cb75b93318ed814fcd753b4890b465cb.svg";
export { ForwardRef as ReactComponent };